import { render, staticRenderFns } from "./TransferBankDetails.vue?vue&type=template&id=42de355b&"
import script from "./TransferBankDetails.vue?vue&type=script&lang=js&"
export * from "./TransferBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferBankDetails.vue"
export default component.exports